import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {t} from '@lingui/core/macro';

import {maxChatAPI} from 'entities/notification';
import MaxChat from 'shared/ui/icons/MaxChat';

import {ICreateGatedModalProps} from 'entities/user';

import BotChatModal from '../NotifyChannel/BotChat/BotChatModal';

const MaxChatModal: React.FC<ICreateGatedModalProps> = ({open, handleClose}) => (
    <BotChatModal
        open={open}
        handleClose={handleClose}
        header={t`Добавить Max`}
        botUrl={AppUrls.MAX_BOT}
        buttonIcon={<MaxChat color="white"/>}
        useAddMutation={maxChatAPI.useAddMutation}
        intro={
            <>
                {t`Нажмите`} <b>«{t`Получить токен`}»</b> {t`и выберите «Начать» или отправьте команду`}{' '}
                <b>/start</b> — {t`бот пришлёт токен, который нужно ввести в форму ниже`}.
            </>
        }
    />
);

export default MaxChatModal;
